'use client';

import { useRef } from 'react';
import ParticleBackground from './ParticleBackground';
import HeroContent from './HeroContent';

interface HeroInteractiveProps {
  lang?: 'en' | 'de';
}

export default function HeroInteractive({ lang = 'en' }: HeroInteractiveProps) {
  const sectionRef = useRef<HTMLElement>(null);

  return (
    <section ref={sectionRef} id="home" className="relative min-h-screen overflow-hidden">
      <ParticleBackground containerRef={sectionRef} />
      <HeroContent lang={lang} />
    </section>
  );
}